import {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {selectAccountDetails} from 'src/modules/profile/account/services/account-page-slice';

export const useConferenceAccountCheck = () => {
    const {hierarchy} = useSelector(selectAccountDetails);

    return useMemo(() => hierarchy?.current && hierarchy.current.entityTypeCode === 'Event', [hierarchy]);
};
